import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { RoadmapperRuntime } from './App';
import '@topolo-io/design-tokens/tokens.css';
import '@topolo-io/onboarding/styles.css';
import '@topolo-io/tour/styles.css';
import './index.css';
import { removeLegacyApiCache } from './lib/legacy-cache';

// Authenticated responses must never remain in the old URL-only PWA cache.
void removeLegacyApiCache();

createRoot(document.getElementById('root')!).render(
  <StrictMode><RoadmapperRuntime registerServiceWorker={registerSW} /></StrictMode>,
);
